import apiClient from "./apiClient";

let csrfToken: string | null = null;

export async function initializeCsrfToken() {
	try {
		const response = await apiClient.get("/csrf-token", {
			withCredentials: true,
		});
		csrfToken = response.data.csrfToken;
		if (csrfToken) {
			localStorage.setItem("csrf-token", csrfToken);
		}
	} catch (error) {
		console.error("Failed to initialize CSRF token:", error);
	}
}
